import "./Testimonials.scss";

export default function Testimonials() {
  const data = [
    {
      id: 1,
      name: "Praduman Rapria",
      title: "Team Leader",
      img: "assets/praduman.jfif",
      icon: "assets/linkedin.png",
      desc: "I highly recommend Kapil for anyone in need of a new website. They were able to bring my vision to life and the end result was exactly what I was looking for. Thank you Kapil",
      link: "https://www.linkedin.com/in/praduman-rapria-b75552118/",
    },
    {
      id: 2,
      name: "Ravi Jetani",
      title: "Co-Founder of eDelta",
      img: "assets/ravi.jfif",
      icon: "assets/linkedin.png",
      desc: "Working with Kapil was a pleasure. They were professional, efficient, and delivered a fantastic website that I am proud to share with my customers. Thank you for your excellent work!",
      link: "https://www.linkedin.com/in/ravijetani/",
      featured: true,
    },
    {
      id: 3,
      name: "Yagnesh Dhanani",
      title: "Senior Developer",
      img: "assets/yagnesh.jfif",
      icon: "assets/linkedin.png",
      desc: "I was blown away by the level of expertise and professionalism shown by Kapil. They helped me take my business to the next level with a beautiful and functional website. Thank you Kapil",
      link: "https://www.linkedin.com/in/yagneshdhanani/",
    },
  ];
  return (
    <div className="testimonials" id="testimonials">
      <h1>Testimonials</h1>
      <div className="container">
        {data.map((d) => (
          <div className={d.featured ? "card featured" : "card"} key={d.id}>
            <div className="top">
              <img src="assets/right-arrow.png" className="left" alt="image" />
              <img className="user" src={d.img} alt="" />
              <a href={d.link} target="_blank">
                <img className="right" src={d.icon} alt="" />
              </a>
            </div>
            <div className="center">{d.desc}</div>
            <div className="bottom">
              <h3>{d.name}</h3>
              <h4>{d.title}</h4>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
